import React, {useCallback} from 'react';
import {Alert, LinearProgress} from "@mui/material";
import cl from "../BaseSimplePage/BaseSimpleItemBrowser.module.css";
import AutoSizer from "react-virtualized-auto-sizer";
import {FixedSizeList} from "react-window";
import EventDraftsItemBrowserItem from "./EventDraftsItemBrowserItem";

const EventDraftsItemBrowserSection = ({
                                           browserState,
                                           mainErrorMessage,
                                           state,
                                           onItemSelect,
                                           getItemTitleFunc,
                                           getItemSubtitleFunc,
                                           getItemUptitleFunc,
                                           sortType,
                                           requestMoreItems,
                                           refreshCounter,
                                           skin,
                                       }) => {

    const filteredItems = state.filteredItems;
    const selectedItemId = state.selectedItemId;
    const status = browserState.status;
    const pagination = browserState.pagination;

    function renderListRow({index, style, data}) {

        const item = data[index];

        return (
            <EventDraftsItemBrowserItem
                style={style}
                id={item.id}
                title={getItemTitleFunc ? getItemTitleFunc(item) : item.name}
                subtitle={getItemSubtitleFunc ? getItemSubtitleFunc(item) : ""}
                uptitle={getItemUptitleFunc ? getItemUptitleFunc(item) : ""}
                selected={item.id === selectedItemId}
                onClick={() => {
                    onItemSelect(item.id);
                }}
                skin={skin}
            />
        );
    }

    return (
        <div style={{flexGrow: "1", display: "flex", flexDirection: "column"}}>
            {(status === "mainLoad" || status === "typing") && <LinearProgress/>}
            {status === "mainError" && <Alert variant="outlined" severity="error">{mainErrorMessage}</Alert>}
            {filteredItems.length > 0 &&
                <div className={cl.itemList}>
                    <MyList
                        filteredItems={filteredItems}
                        getListItemKey={getListItemKey}
                        renderListRow={renderListRow}
                        selectedItemId={selectedItemId}
                        sortType={sortType}
                        requestMoreItems={requestMoreItems}
                        pagination={status === "idle" ? pagination : null}
                        refreshCounter={refreshCounter}
                    />
                </div>}
        </div>
    );
};

const MyList = ({
                    filteredItems,
                    getListItemKey,
                    renderListRow,
                    selectedItemId,
                    sortType,
                    requestMoreItems,
                    pagination,
                    refreshCounter
                }) => {

    const listRef = useCallback(node => {
        //console.log(">>> cb", "node=", node)
        if (node !== null) {
            if (selectedItemId) {
                const item = filteredItems.find(x => x.id === selectedItemId);
                if (item) {
                    node.scrollToItem(filteredItems.indexOf(item), "smart");
                }
            }
        }
        //}, [filteredItems, selectedItemId, sortType, refreshCounter]);
    }, [selectedItemId, sortType, refreshCounter]);

    return <AutoSizer>
        {({height, width}) => (
            <FixedSizeList
                ref={listRef}
                width={width}
                height={height}
                itemCount={filteredItems.length}
                itemSize={80}
                overscanCount={150}
                itemData={filteredItems}
                itemKey={getListItemKey}
                onItemsRendered={({visibleStopIndex}) => {
                    if (pagination && !pagination.is_last && visibleStopIndex + 1 >= filteredItems.length) {
                        requestMoreItems();
                    }
                }}
            >
                {renderListRow}
            </FixedSizeList>)}
    </AutoSizer>
}

function getListItemKey(index, data) {
    return data[index].id;
}

export default EventDraftsItemBrowserSection;